__webpack_require__.p = "/stream-annotation-studio/";